import { Controller } from "@hotwired/stimulus"

// The prototype's language <select>. Each <option> carries the server-built
// localized URL in data-url; changing the select navigates there. Falls back
// gracefully: with JS off the select simply doesn't navigate (the funnel is
// still reachable via the locale-prefixed URLs).
export default class extends Controller {
  change(event) {
    const option = event.target.selectedOptions[0]
    const url = option && option.dataset.url
    if (url) window.location.assign(url)
  }
}
